import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import atbsTranslations from "./atbsTranslations";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    //debug: true,
    lng: "ro", // Default language
    resources: {
      en: {
        translation: {
          atbs: atbsTranslations.en,
          errors: {
            home: "Back to home",
            reload: "Reload page",
            403: {
              title: "Access denied",
              description: "You do not have permission to access this page.",
            },
            404: {
              title: "Page not found",
              description: "The page you are looking for does not exist or has been moved. Please check the address or return to the home page.",
            },
            500: {
              title: "Something went wrong",
              description: "We could not display this page. Please reload it or try again later.",
            },
            503: {
              title: "Temporarily unavailable",
              description: "This service is temporarily unavailable. Please try again later.",
            },
          },
          intro:
            "The ASR-CERTPERS project aims to develop a certification scheme for the assessment of the skills and competences of professionals in the field of welding.",
          mission_title: "Mission",
          mission_description:
            "The mission of ASR-CertPers is to implement the IIW-IAB/EWF qualification/certification guidelines in Romania.",
          history_title: "History",
          history_description: `ASR-CertPers is the designated authorized body for the qualification and certification of welding personnel, established by the decision of the General Assembly of the Romanian Welding Society (ASR) of 25 October 2000, the memorandum of 12 August 2011, and Legal Decree No. 12748/20 November 2011. The development of ASR-CertPers is closely linked to Romania’s integration into European and international systems for the qualification and certification of welding personnel.

Following the establishment of the Romanian Welding Society (ASR) in 1990 and the development of its relations with the European Federation for Welding (EWF), harmonized European systems for the qualification of welding personnel began to be implemented in Romania in the first half of the 1990s. In 1994, the European Welding Engineer qualification system was introduced, subsequently complemented by international qualifications developed by the International Institute of Welding (IIW).

In order to manage these activities independently and consistently, ASR-CertPers was established in 1997 by a decision of the General Assembly of the Romanian Welding Society as a body responsible for the qualification and certification of welding personnel. Beginning in 2000, the organization operated within S.C. ASR-CertPers S.R.L. Timișoara, a company whose shareholders are the Romanian Welding Society and the National Research and Development Institute for Welding and Material Testing – ISIM Timișoara.

ASR-CertPers became the Authorised National Body (ANB) for Romania within the European and international systems for the qualification of welding personnel, implementing in Romania the guidelines and requirements developed by EWF and IIW/IAB. Through Approved Training Bodies (ATBs), the organization ensured the monitoring of the training process, the examination of candidates, and the awarding of diplomas recognized within the international IIW/EWF system.

Over the course of its development, the scope of ASR-CertPers activities expanded from the qualification of welding engineers to other professional categories, including welding technologists, welding specialists, welding inspectors, welding practitioners, and other qualifications developed in accordance with EWF and IIW guidelines. This development responded to the industry’s need for personnel with professional competencies recognized on the basis of harmonized European and international requirements.

An important milestone was the introduction of professional competence certification as a complement to the qualification system. Beginning in December 2009, ASR-CertPers implemented the IIW/EWF scheme for the certification of welding coordination personnel. The scheme took into account not only the theoretical knowledge demonstrated through an IIW/EWF diploma, but also recent professional experience, the maintenance and development of competencies, and the periodic assessment of professional activity. The first certificates awarded under this scheme in Romania were issued at the beginning of the system’s implementation.

In the following years, the system continued to develop through the updating of procedures, the adoption of harmonized question databases for examinations, the authorization and supervision of training bodies, and the introduction of new qualifications. ASR-CertPers thus strengthened its role as the national interface between Romania’s welding industry and community and the international education, qualification, and certification system developed by IIW and EWF.

At present, ASR-CertPers continues to hold the status of Authorised National Body (ANB) for Romania and is included by the European Federation for Welding (EWF) in the list of ANBs authorized for international and European personnel qualification and certification systems.

Its activities cover, among others, qualifications such as International/European Welding Engineer (IWE/EWE), International/European Welding Specialist (IWS/EWS), International Welding Inspector (IWI), and International Welding Structure Designer (IWSD), as well as the certification of welding coordination personnel.

`,
          history_description_short:
            "ASR-CertPers is the designated authorized body for the qualification and certification of welding personnel, established by the decision of the General Assembly of the Romanian Welding Society (ASR) of 25 October 2000, the memorandum of 12 August 2011, and Legal Decree No. 12748/20 November 2011.",
          home_tab: "Home",
          structure_tab: "Structure",
          certifications_tab: "Certifications",
          downloads_tab: "Downloads",
          contacts_tab: "Contacts",
          contact_secretariat: "Secretariat",
          contact_phone: "Phone",
          contact_email: "Email",
          certifications_title: "CERTIFICATIONS",
          certifications_subtitle:
            "What certifications does ASR-CERTPERS offer?",
          certifications_description:
            "ASR-CERTPERS offers a range of certifications designed to validate the skills and knowledge of professionals in the field of welding. These certifications are recognized across the industry and help individuals demonstrate their expertise.",
          downloads_title: "DOWNLOADS",
          downloads_subtitle:
            "What resources are available for ASR-CERTPERS certifications?",
          downloads_description:
            "Access various resources, including certification guidelines, application forms, and informational brochures related to ASR-CERTPERS certifications.",
          services_title: "SERVICES",
          services_subtitle: "What services does ASR-CERTPERS offer?",
          services_description:
            "ASR-CERTPERS provides a variety of services to support professionals in welding, including training programs, workshops, and consultancy services to enhance their skills and career prospects.",
          number_of_certifications: "Number of diplomas / certificates issued:",
          certificates_year_title: "Diplomas and certificates issued in {{year}}",
          certificates_cumulative_title:
            "Cumulative totals up to the end of {{year}} (all years)",
          certificate_iwi_b_title:
            "International Welding Inspector — Basic Level (IWI-B)",
          certificate_iwsd_s_title:
            "International Welded Structures Designer — Standard Level (IWSD-S)",
          certificate_iwsd_c_title:
            "International Welded Structures Designer — Comprehensive Level (IWSD-C)",
          certificate_ewip_title: "European Welding Inspection Personnel (EWIP)",
          certificate_iwe_title: "International Welding Engineer (IWE)",
          certificate_ewe_title: "European Welding Engineer (EWE)",
          certificate_iwi_c_title:
            "International Welding Inspector — Comprehensive Level (IWI-C)",
          certificate_ewi_c_title:
            "European Welding Inspector — Comprehensive Level (EWI-C)",
          certificate_iwi_s_title:
            "International Welding Inspector — Standard Level (IWI-S)",
          certificate_ewi_s_title:
            "European Welding Inspector — Standard Level (EWI-S)",
          certificate_iwt_title: "International Welding Technologist (IWT)",
          certificate_ewt_title: "European Welding Technologist (EWT)",
          certificate_iws_title: "International Welding Specialist (IWS)",
          certificate_ews_title: "European Welding Specialist (EWS)",
          certificate_iwsd_title: "International Welded Structures Designer (IWSD)",
          certificate_c_iwe_title: "Certified International Welding Engineer (C-IWE)",
          certificate_type1_title:
            "International Welded Structure Designer Comprehensive Level (IWSD-C)",
          number_of_certifications_title: "Number of certifications issued:",
          download_report_title: "Download Our Latest Report",
          download_report_label: "Download Report",
          download_regulations_title: "Download Regulations",
          download_name_pdf: "Download PDF",
          download_cv_title: "Download CV",
          scroll_down_to_content: "Scroll down to view the content",
          direction_committee_title: "STEERING COMMITTEE",
          direction_committee_subtitle:
            "ASR-CertPers Steering Committee members",
          direction_committee_description:
            "Meet the members of the ASR-CertPers Steering Committee and download their CVs.",
          download_name_word: "Download Word",
          news_title: "Latest News",
          news_article1_link_name:
            "23–24 April 2026, Craiova – ASR Conference ‘Welding 2026’",
          news_article2_link_name:
            "15–16 October 2026, Sibiu – ASR Annual Conference of Welding Coordinators",
          news_article3_link_name:
            "05–06 November 2026, Timișoara – innoCENTA – International Exhibition of Innovation and Technological Transfer",
          news_article4_link_name:
            "05–06 November 2026, Timișoara – TIMA26 – International Conference ‘Innovative Technologies for Joining Advanced Materials’",

          rof: "Organization and Functioning Regulations",
          rdc: "Steering Committee Regulations",

          contact_us_footer: "Contact us at",
          all_rights_reserved_footer: "All rights reserved",
          activity_report_2025_title: "Report on ASR-CertPers Activity 2025",
          activity_report_2025_text:
            "The report provides a detailed overview of ASR-CertPers' achievements and progress in 2025.",
          activity_report_2025_download_title: "Download 2025 Report",
          activity_report_2025_download_name_pdf: "Download PDF",
          activity_report_2024_title: "Report on ASR-CertPers Activity 2024",
          activity_report_2024_text:
            "The report provides a detailed overview of ASR-CertPers' achievements and progress in 2024.",
          activity_report_2024_download_title: "Download 2024 Report",
          activity_report_2024_download_name_pdf: "Download PDF",

          direction_committee_tab: "Steering Committee",
          examination_committee_title: "EXAMINATION COMMITTEES",
          examination_committee_subtitle:
            "ASR-CertPers examination and certification committees",
          examination_committee_description:
            "Select a committee to view its members, grouped by year.",
          examination_committee_iwe_title:
            "Examination Committee for International Welding Engineer (IWE)",
          examination_committee_iwt_title:
            "Examination Committee for International Welding Technologist (IWT)",
          examination_committee_iws_title:
            "Examination Committee for International Welding Specialist (IWS)",
          examination_committee_iwi_title:
            "Examination Committee for International Welding Inspector (IWI)",
          certification_committee_c_iwe_title:
            "Certification Committee for the C-IWE Qualification",
          examination_committee_iwsd_title: "Examination Committee for IWSD",
          examination_committee_rmwf_title:
            "RMWF Examination Committee Members",
          examination_committee_iw_title:
            "Examination Committee for International Welder (IW)",
          examination_committee_tab: "Examination Committees",
        },
      },
      ro: {
        translation: {
          atbs: atbsTranslations.ro,
          errors: {
            home: "Înapoi acasă",
            reload: "Reîncarcă pagina",
            403: {
              title: "Acces interzis",
              description: "Nu ai permisiunea de a accesa această pagină.",
            },
            404: {
              title: "Pagina nu a fost găsită",
              description: "Pagina căutată nu există sau a fost mutată. Verifică adresa sau revino la pagina principală.",
            },
            500: {
              title: "A apărut o eroare",
              description: "Nu am putut afișa această pagină. Reîncarcă pagina sau încearcă din nou mai târziu.",
            },
            503: {
              title: "Temporar indisponibil",
              description: "Acest serviciu este temporar indisponibil. Te rugăm să încerci din nou mai târziu.",
            },
          },
          intro:
            "Proiectul ASR-CERTPERS își propune să dezvolte un sistem de certificare pentru evaluarea abilităților și competențelor profesioniștilor în domeniul sudării.",
          mission_title: "Misiune",
          mission_description:
            "Misiunea ASR-CertPers este de a implementa în România ghidurile de calificare/certificare IIW-IAB/EWF.",
          history_title: "Istoric",
          history_description: `ASR-CertPers este organismul nominalizat autorizat pentru calificarea/certificarea personalului de sudare, fondat prin decizia Adunării Generale a Asociației Române de Sudură (ASR) din 25 octombrie 2000 și memorandumul din 12.08.2011 precum și decretul legal nr. 12748 / 20.11.2011. Dezvoltarea ASR-CertPers este strâns legată de procesul de integrare a României în sistemele europene și internaționale de calificare și certificare a personalului din domeniul sudării.

După înființarea Asociației de Sudură din România – ASR în anul 1990 și dezvoltarea relațiilor acesteia cu Federația Europeană de Sudură – EWF, în România au început să fie implementate, începând cu prima jumătate a anilor 1990, sistemele europene armonizate de calificare a personalului sudor. În anul 1994 a fost introdus sistemul de calificare a Inginerului Sudor European, ulterior acesta fiind completat cu calificările internaționale dezvoltate de Institutul Internațional de Sudură – IIW.

Pentru administrarea independentă și coerentă a acestor activități, în anul 1997, prin hotărârea Adunării Generale a Asociației de Sudură din România, a fost creat ASR-CertPers, organism destinat calificării și certificării personalului din domeniul sudării. Începând cu anul 2000, activitatea organismului s-a desfășurat în cadrul S.C. ASR-CertPers S.R.L. Timișoara, societate având ca asociați Asociația de Sudură din România și Institutul Național de Cercetare-Dezvoltare în Sudură și Încercări de Materiale – ISIM Timișoara.

ASR-CertPers a devenit Organismul Național Autorizat – ANB (Authorised National Body) pentru România în cadrul sistemelor europene și internaționale de calificare a personalului din domeniul sudării, implementând în România ghidurile și cerințele elaborate de EWF și IIW/IAB. Prin intermediul centrelor de formare aprobate – ATB (Approved Training Bodies) – organismul a asigurat monitorizarea procesului de formare, examinarea candidaților și acordarea diplomelor recunoscute în cadrul sistemului internațional IIW/EWF.

Pe parcursul dezvoltării sale, domeniul de activitate al ASR-CertPers s-a extins de la calificarea inginerilor sudori la alte categorii profesionale, printre care tehnolog sudor, specialist sudor, inspector sudor, practician sudor și alte calificări dezvoltate conform ghidurilor EWF și IIW. Această evoluție a răspuns necesității industriei de a dispune de personal cu competențe profesionale recunoscute pe baza unor cerințe armonizate la nivel european și internațional.

O etapă importantă a fost reprezentată de introducerea certificării competenței profesionale, complementară sistemului de calificare. Începând cu luna decembrie 2009, ASR-CertPers a implementat schema IIW/EWF pentru certificarea personalului de coordonare a sudării. Schema lua în considerare nu numai pregătirea teoretică demonstrată prin diploma IIW/EWF, ci și experiența profesională recentă, menținerea și dezvoltarea competențelor și evaluarea periodică a activității profesionale. Primele certificate acordate în cadrul acestei scheme în România au fost emise la începutul implementării sistemului.

În anii următori, sistemul a continuat să se dezvolte prin actualizarea procedurilor, adoptarea bazelor armonizate de întrebări pentru examinare, autorizarea și supravegherea centrelor de formare și introducerea unor noi calificări. ASR-CertPers și-a consolidat astfel rolul de interfață națională între industria și comunitatea de sudare din România și sistemul internațional de educație, calificare și certificare dezvoltat de IIW și EWF.

În prezent, ASR-CertPers continuă să dețină statutul de Organism Național Autorizat pentru România, fiind inclus de Federația Europeană de Sudură în lista ANB-urilor autorizate pentru sistemele internaționale și europene de calificare și certificare a personalului. Activitatea sa acoperă, între altele, calificări precum International/European Welding Engineer – IWE/EWE, International/European Welding Specialist – IWS/EWS, International Welding Inspector – IWI și International Welding Structure Designer – IWSD, precum și certificarea personalului de coordonare a sudării.`,
          history_description_short:
            "ASR-CertPers este organismul nominalizat autorizat pentru calificarea/certificarea personalului de sudare, fondat prin decizia Adunării Generale a Asociației Române de Sudură (ASR) din 25 octombrie 2000 și memorandumul din 12.08.2011 precum și decretul legal nr. 12748 / 20.11.2011.",
          structure_tab: "Organizare",
          home_tab: "Acasă",
          certifications_tab: "Certificate",
          downloads_tab: "Descărcări",
          contacts_tab: "Contacte",
          contact_secretariat: "Secretariat",
          contact_phone: "Telefon",
          contact_email: "Email",
          certifications_title: "CERTIFICĂRI",
          certifications_subtitle: "Ce certificări oferă ASR-CERTPERS?",
          certifications_description:
            "ASR-CERTPERS oferă o gamă de certificări concepute pentru a valida abilitățile și cunoștințele profesioniștilor în domeniul sudării. Aceste certificări sunt recunoscute în întreaga industrie și ajută indivizii să își demonstreze expertiza.",
          downloads_title: "DESCĂRCĂRI",
          downloads_subtitle:
            "Ce resurse sunt disponibile pentru certificările ASR-CERTPERS?",
          downloads_description:
            "Accesați diverse resurse, inclusiv ghiduri de certificare, formulare de aplicare și broșuri informative legate de certificările ASR-CERTPERS.",
          services_title: "SERVICII",
          services_subtitle: "Ce servicii oferă ASR-CERTPERS?",
          services_description:
            "ASR-CERTPERS oferă o varietate de servicii pentru a sprijini profesioniștii în domeniul sudării, inclusiv programe de formare, ateliere și servicii de consultanță pentru a-și îmbunătăți abilitățile și perspectivele de carieră.",
          number_of_certifications: "Număr de diplome / certificate eliberate:",
          certificates_year_title: "Diplome și certificate eliberate în {{year}}",
          certificates_cumulative_title:
            "Totaluri cumulative până la sfârșitul anului {{year}} (toți anii)",
          certificate_iwi_b_title:
            "Inspector Sudor Internațional — nivel Basic (IWI-B)",
          certificate_iwsd_s_title:
            "Proiectant Internațional Structuri Sudate — nivel Standard (IWSD-S)",
          certificate_iwsd_c_title:
            "Proiectant Internațional Structuri Sudate — nivel Comprehensiv (IWSD-C)",
          certificate_ewip_title: "Personal European de Inspecție a Sudării (EWIP)",
          certificate_iwe_title: "Inginer Sudor Internațional (IWE)",
          certificate_ewe_title: "Inginer Sudor European (EWE)",
          certificate_iwi_c_title:
            "Inspector Sudor Internațional — nivel Comprehensiv (IWI-C)",
          certificate_ewi_c_title:
            "Inspector Sudor European — nivel Comprehensiv (EWI-C)",
          certificate_iwi_s_title:
            "Inspector Sudor Internațional — nivel Standard (IWI-S)",
          certificate_ewi_s_title:
            "Inspector Sudor European — nivel Standard (EWI-S)",
          certificate_iwt_title: "Tehnolog Sudor Internațional (IWT)",
          certificate_ewt_title: "Tehnolog Sudor European (EWT)",
          certificate_iws_title: "Specialist Sudor Internațional (IWS)",
          certificate_ews_title: "Specialist Sudor European (EWS)",
          certificate_iwsd_title: "Proiectant Internațional Structuri Sudate (IWSD)",
          certificate_c_iwe_title: "Inginer Sudor Internațional Certificat (C-IWE)",
          certificate_type1_title:
            "Proiectant internaţional de structuri sudate nivel comprehensiv (IWSD-C)",
          number_of_certifications_title: "Număr de certificări emise:",
          download_report_title: "Descarcă Raportul Nostru Recent",
          download_report_label: "Descarcă Raport",
          download_regulations_title: "Descarcă Regulament",
          download_name_pdf: "Descarcă PDF",
          download_cv_title: "Downloadează CV",
          scroll_down_to_content: "Derulează în jos pentru a vedea conținutul",
          direction_committee_title: "COMITET DE DIRECȚIE",
          direction_committee_subtitle:
            "Membrii Comitetului de Direcție ASR-CertPers",
          direction_committee_description:
            "Cunoaște membrii Comitetului de Direcție ASR-CertPers și descarcă CV-urile acestora.",
          download_name_word: "Descarcă Word",
          news_title: "Știri Recente",
          news_article1_link_name:
            "23–24 aprilie 2026, Craiova – Conferința ASR „Sudura 2026”",
          news_article2_link_name:
            "15–16 octombrie 2026, Sibiu – Conferința anuală ASR a coordonatorilor sudării",
          news_article3_link_name:
            "05–06 noiembrie 2026, Timișoara – innoCENTA – Expoziția internațională de inovare și transfer tehnologic",
          news_article4_link_name:
            "05–06 noiembrie 2026, Timișoara – TIMA26 – Conferința internațională „Tehnologii inovatoare pentru îmbinarea materialelor avansate”",
          rof: "Regulament de Organizare și Funcționare",
          rcd: "Regulament Comitet Director",

          contact_us_footer: "Contactați-ne la",
          all_rights_reserved_footer: "Toate drepturile rezervate",
          activity_report_2025_title:
            "Raport referitor la activitatea ASR-CertPers 2025",
          activity_report_2025_text:
            "Raportul oferă o privire detaliată asupra realizărilor și progreselor ASR-CertPers în anul 2025.",
          activity_report_2025_download_title: "Descarcă Raportul 2025",
          activity_report_2025_download_name_pdf: "Descarcă PDF",
          activity_report_2024_title:
            "Raport referitor la activitatea ASR-CertPers 2024",
          activity_report_2024_text:
            "Raportul oferă o privire detaliată asupra realizărilor și progreselor ASR-CertPers în anul 2024.",
          activity_report_2024_download_title: "Descarcă Raportul 2024",
          activity_report_2024_download_name_pdf: "Descarcă PDF",

          direction_committee_tab: "Comitet de Direcție",
          examination_committee_title: "COMISII DE EXAMINARE",
          examination_committee_subtitle:
            "Comisiile de examinare și certificare ASR-CertPers",
          examination_committee_description:
            "Selectează o comisie pentru a vedea membrii acesteia, grupați pe ani.",
          examination_committee_iwe_title:
            "Comisia de examinare pentru inginerul sudor internațional (IWE)",
          examination_committee_iwt_title:
            "Comisia de examinare pentru tehnologul sudor internațional (IWT)",
          examination_committee_iws_title:
            "Comisia de examinare pentru specialist sudor internațional (IWS)",
          examination_committee_iwi_title:
            "Comisia de examinare pentru inspector sudor internațional (IWI)",
          certification_committee_c_iwe_title:
            "Comisia de certificare pentru calificarea ca C-IWE",
          examination_committee_iwsd_title: "Comisia de examinare pentru IWSD",
          examination_committee_rmwf_title:
            "Componența comisiei de examinare ca RMWF",
          examination_committee_iw_title:
            "Comisia de examinare pentru sudorul internațional (IW)",

          examination_committee_tab: "Comisii de Examinare",
        },
      },
    },
  })
  .catch((err) => {
    console.error("i18n initialization failed:", err);
  });
